import PodManagement from 'components/organisms/pod-management';

import s from './styles.module.scss';

const AdminPodManagementPage = () => {
  return (
    <div className={s.wrapper}>
      <PodManagement />
    </div>
  );
};

export default AdminPodManagementPage;
